import axios from "axios";
import { getServerDomain } from "./utils";

export const caxios = axios.create({
  baseURL: getServerDomain(),
  withCredentials: true,
});
